// component
import {
  People,
  LocalShipping,
  AddBusiness,
  LocalMall,
  Diversity3,
  AddShoppingCart,
  ShoppingCart,
  ShoppingCartCheckout,
  ProductionQuantityLimits,
  KeyboardReturn,
  CurrencyExchange,
  PriceChange,
  ArrowCircleDown,
  Assessment,
  DriveFolderUpload,
  UploadFile,
  Book,
  QrCode,
  DeviceHub,
  PointOfSale,
  Inventory,
  Assignment,
  MoveDown,
  Kitchen,
  TableView,
  Person,
  Discount,
  LocationCity,
  CurrencyRupee,
  Warehouse,
  LocationOn,
  NotificationAdd,
  Dashboard,
  Settings,
  KeyboardDoubleArrowDown,
  Inventory2,
  NotificationImportant,
  PictureAsPdf,
  Analytics
} from "@mui/icons-material";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// ----------------------------------------------------------------------

const navConfig = [
  {
    serviceName: "dashboard",
    permission: "read",
    path: "dashboard",
    title: "Dashboard",
    icon: <Dashboard />,
  },
  {
    serviceName: "customers",
    path: "customers",
    permission: "read",
    title: "Customers",
    icon: <Diversity3 />,
  },
  {
    serviceName: "products",
    title: "Products",
    permission: "read",
    icon: <LocalMall />,
    childs: [
      {
        serviceName: "products",
        path: "products",
        permission: "read",
        title: "Products List",
        icon: <TableView />,
      },
      {
        serviceName: "products",
        path: "productTransactions",
        permission: "read",
        title: "Products Transactions",
        icon: <ReceiptLongIcon />,
      },
      {
        serviceName: "updatePricing",
        path: "updatePricing",
        permission: "update",
        title: "Update Pricing",
        icon: <PriceChange />,
      },
      {
        serviceName: "uploadImages",
        path: "uploadImages",
        permission: "create",
        title: "Upload Images",
        icon: <DriveFolderUpload />,
      },
      {
        serviceName: "uploadImagesNew",
        path: "uploadImagesNew",
        permission: "create",
        title: "Upload Images New",
        icon: <DriveFolderUpload />,
      },
      {
        serviceName: "uploadOtherMaster",
        path: "uploadOthersMaster",
        permission: "create",
        title: "Upload Others Master",
        icon: <UploadFile />,
      },
      {
        serviceName: "skuToQrcodeBarcode",
        path: "skuToQrcodeBarcode",
        permission: "read",
        title: "Sku To Qrcode/Barcode",
        icon: <QrCode />,
      },
      // {
      //   serviceName: "reportService",
      //   path: "productsCreated",
      //   permission: "read",
      //   title: "Report Service",
      //   icon: <Assessment />,
      // },
      {
        serviceName: "reportService",
        path: "reportServiceNew",
        permission: "read",
        title: "Report Service",
        icon: <Assessment />,
      },
    ],
  },
  {
    serviceName: "orders",
    title: "Orders",
    permission: "read",
    icon: <AddBusiness />,
    childs: [
      {
        serviceName: "createOrder",
        permission: "create",
        path: "createOrder",
        title: "Create Order",
        icon: <AddShoppingCart />,
      },
      {
        serviceName: "draftOrder",
        path: "draftOrdersNew",
        permission: "read",
        title: "Draft Order",
        icon: <ShoppingCartCheckout />,
      },
      // {
      //   serviceName: "draftOrders",
      //   path: "draftOrdersNew",
      //   permission: "read",
      //   title: "Draft Order v2",
      //   icon: <ShoppingCartCheckout />,
      // },
      {
        serviceName: "orders",
        path: "ordersNew",
        permission: "read",
        title: "Orders List",
        icon: <ShoppingCart />,
      },
      {
        serviceName: "orders",
        path: "docsList",
        permission: "read",
        title: "Docs List",
        icon: <PictureAsPdf />,
      },
      {
        serviceName: "deliveryShipping",
        path: "deliveryShipping",
        permission: "read",
        title: "Delivery Shipping",
        icon: <LocalShipping />,
      },
      // {
      //   serviceName: "dispatch",
      //   path: "dispatch",
      //   permission: "read",
      //   title: "Dispatch",
      //   icon: <AirportShuttle />,
      // },
      {
        serviceName: "deliveryRiders",
        path: "deliveryRiders",
        permission: "read",
        title: "Delivery Riders",
        icon: <LocalShipping />,
      },
      {
        serviceName: "returnOrder",
        path: "returnsNew",
        permission: "read",
        title: "Returns",
        icon: <KeyboardReturn />,
      },
      {
        serviceName: "inwardReturns",
        path: "inwardReturns",
        permission: "read",
        title: "Inward Returns",
        icon: <LocalShipping />,
      },
      {
        serviceName: "cancelOrder",
        path: "cancelsNew",
        permission: "read",
        title: "Cancels",
        icon: <ProductionQuantityLimits />,
      },
      {
        serviceName: "refundOrder",
        path: "refundsNew",
        permission: "read",
        title: "Refunds",
        icon: <CurrencyExchange />,
      },
      // {
      //   serviceName: "deliveryBoy",
      //   path: "deliveryBoy",
      //   permission: "read",
      //   title: "Delivery",
      //   icon: <LocalShipping />,
      // },
    ],
  },
  {
    serviceName: "purchaseOrders",
    title: "Purchase Orders",
    permission: "read",
    icon: <AddBusiness />,
    childs: [
      {
        serviceName: "purchaseOrders",
        path: "createPurchaseOrder",
        permission: "create",
        title: "Create P.O",
        icon: <AddShoppingCart />,
      },
      {
        serviceName: "draftPurchaseOrders",
        path: "draftPurchaseOrders",
        permission: "read",
        title: "Draft P.O",
        icon: <ShoppingCartCheckout />,
      },
      {
        serviceName: "purchaseOrders",
        path: "purchaseOrders",
        permission: "read",
        title: "Purchase Orders",
        icon: <ShoppingCart />,
      },
      {
        serviceName: "inboundPurchaseOrders",
        path: "inboundPurchaseOrders",
        permission: "read",
        title: "Inbound P.Os",
        icon: <ArrowCircleDown />,
      },
      {
        serviceName: "inwardPurchaseOrders",
        path: "inwardPurchaseOrders",
        permission: "read",
        title: "Inward Po",
        icon: <LocalShipping />,
      },
    ],
  },
  {
    serviceName: "procurements",
    title: "Procurements",
    permission: "read",
    icon: <ShoppingCartCheckout />,
    childs: [
      {
        serviceName: "lowInventoryTracker",
        path: "lowInventoryTracker",
        permission: "read",
        title: "Inventory Tracker",
        icon: <KeyboardDoubleArrowDown />,
      },
      {
        serviceName: "inventoryAnalytics",
        path: "inventoryAnalytics",
        permission: "read",
        title: "Inventory Analytics",
        icon: <Analytics />,
      },
      {
        serviceName: "inventoriesWithAllLocations",
        path: "inventoriesWithAllLocations",
        permission: "read",
        title: "All Locations",
        icon: <Analytics />,
      },
      {
        serviceName: "InventoriesWithPurchaseOrderDetails",
        path: "inventoriesWithPurchaseOrderDetails",
        permission: "read",
        title: "Insights",
        icon: <Inventory2 />,
      },
      {
        serviceName: "myNotifications",
        path: "settings/myNotifications",
        permission: "read",
        title: "My Notifications",
        icon: <NotificationImportant />,
      },
      {
        serviceName: "inventory",
        path: "inventoryStockOut",
        permission: "read",
        title: "Stock Out",
        icon: <MoveDown />,
      },
    ],
  },
  {
    serviceName: "scheme",
    title: "Scheme",
    permission: "read",
    icon: <Discount />,
    childs: [
      {
        serviceName: "scheme",
        path: "schemeDashboard",
        permission: "read",
        title: "Dashboard",
        icon: <Assessment />,
      },
      {
        serviceName: "scheme",
        path: "schemes",
        permission: "read",
        title: "Schemes",
        icon: <AddBusiness />,
      },
    ],
  },
  {
    serviceName: "fieldSales",
    title: "Field Sales",
    permission: "read",
    icon: <PointOfSale />,
    childs: [
      {
        serviceName: "salesManager",
        path: "manager",
        title: "Manager",
        permission: "create",
        icon: <Person />,
      },
      {
        serviceName: "fieldSales",
        path: "myTasks",
        title: "My Tasks",
        permission: "create",
        icon: <Assignment />,
      },
      {
        serviceName: "fieldSales",
        path: "myCustomers",
        title: "My Customers",
        permission: "create",
        icon: <Diversity3 />,
      },
    ],
  },
  {
    serviceName: "inventory",
    title: "Inventory",
    permission: "read",
    icon: <Inventory />,
    childs: [
      {
        serviceName: "locations",
        path: "locations",
        permission: "read",
        title: "Locations",
        icon: <LocationCity />,
      },
      {
        serviceName: "interWHInventoryMove",
        path: "createInterWHInventoryMoves",
        permission: "create",
        title: "W/H Inventory Move",
        icon: <Warehouse/>,
      },
      {
        serviceName: "draftInterWarehouseInventoryMoves",
        path: "draftInterWarehouseInventoryMoves",
        permission: "read",
        title: "Draft W/H Inventory Moves",
        icon: <Warehouse/>,
      },
      {
        serviceName: "interWarehouseInventoryMoves",
        path: "interWarehouseInventoryMoves",
        permission: "read",
        title: "Inter W/H Inventory Moves",
        icon: <Warehouse/>,
      },
      // {
      //   serviceName: "inventory",
      //   path: "inventory",
      //   permission: "create",
      //   title: "Inventory Upload",
      //   icon: <Publish />,
      // }
      {
        serviceName: "inventoryView",
        path: "inventoryView",
        permission: "read",
        title: "Inventory View",
        icon: <Assignment />,
      },
      {
        serviceName: "inventoryMove",
        path: "inventoryMove",
        permission: "read",
        title: "Inventory Move",
        icon: <MoveDown />,
      },
      {
        serviceName: "inventoryAdjustments",
        path: "inventoryAdjustments",
        permission: "read",
        title: "Inventory Adjustments",
        icon: <MoveDown />,
      },
      {
        serviceName: "bins",
        path: "bins",
        permission: "read",
        title: "Bins",
        icon: <Kitchen />,
      },
      {
        serviceName: "skuTransactions",
        path: "skuTransactions",
        permission: "read",
        title: "SKU Transactions",
        icon: <MoveDown />,
      },
      {
        serviceName: "orderAllocations",
        path: "orderAllocations",
        permission: "read",
        title: "Order Allocations",
        icon: <ShoppingCartCheckout />,
      },
    ],
  },
  {
    serviceName: "blog",
    path: "blog",
    permission: "read",
    title: "Blog",
    icon: <Book />,
  },
  {
    serviceName: "pushNotifications",
    path: "pushNotifications",
    permission: "read",
    title: "Push Notifications",
    icon: <NotificationAdd />,
  },
  // {
  //   serviceName: "affiliates",
  //   path: "affiliates",
  //   permission: "read",
  //   title: "Affiliates",
  //   icon: <DeviceHub />,
  // },
  // {
  //   serviceName: "fieldSales",
  //   path: "fieldSales",
  //   permission: "read",
  //   title: "Field Sales",
  //   icon: <PointOfSale />,
  // }
  {
    serviceName: "affiliates",
    title: "Affiliates",
    permission: "read",
    icon: <DeviceHub />,
    childs: [
      {
        serviceName: "affiliates",
        path: "/affiliates",
        permission: "read",
        title: "Dashboard",
        icon: <DeviceHub />,
      },
      {
        serviceName: "commissions",
        path: "/commissions",
        permission: "read",
        title: "Commissions",
        icon: <CurrencyRupee />,
      },
      {
        serviceName: "createCommission",
        path: "/createCommission",
        permission: "create",
        title: "Create Commission",
        icon: <CurrencyRupee />,
      },
    ],
  },
  {
    serviceName: "estimates",
    permission: "read",
    path: "estimates",
    title: "Estimates",
    icon: <People />,
  },
  // {
  //   serviceName: "dynamicBanners",
  //   permission: "read",
  //   path: "dynamicBanners",
  //   title: "Dynamic Banners",
  //   icon: <ViewCarousel />,
  // },
  {
    serviceName: "franchiseOwner",
    title: "Franchise",
    permission: "read",
    icon: <People />,
    childs: [
      {
        serviceName: "franchise",
        permission: "read",
        path: "franchise",
        title: "Franchise List",
        icon: <People />,
      },
      {
        serviceName: "products",
        path: "inventoryManagement",
        permission: "read",
        title: "Inventory Management",
        icon: <Warehouse/>,
      },
      {
        serviceName: "products",
        path: "productManagement",
        permission: "update",
        title: "Product Management",
        icon: <LocalMall />,
      },
    ],
  },
  {
    serviceName: "settings",
    permission: "read",
    path: "settings",
    title: "Settings",
    icon: <Settings />,
  },

];

export default navConfig;
